<div class="court-time-grid-wrapper" #wrapperEl [style.maxHeight.px]="wrapperMaxHeight()">
  <app-lead-time-notice [leadTimeMinutes]="leadTimeMinutes()" />

  @if (loading()) {
    <div class="loading-indicator">
      <span class="loading-spinner"></span>
      <span>Lade Platzbelegung...</span>
    </div>
  }

  @if (!loading() && !hasData()) {
    <div class="no-data-message">
      Keine Plätze verfügbar für den gewählten Zeitraum.
    </div>
  }

  @if (!loading() && hasData()) {
    <div class="grid-scroll" #scrollContainer>
      <div class="grid-inner" [style.minWidth.px]="innerMinWidth()">
        <div class="grid-row">
          <div class="time-gutter" [style.height.px]="totalHeightPx()">
            <div class="gutter-header">
              <div class="gutter-nav-row">
                <button
                  type="button"
                  class="gutter-nav-btn"
                  [title]="navPrevTitle()"
                  [attr.aria-label]="navPrevTitle()"
                  (click)="onNavPrev()">‹</button>
                <button
                  type="button"
                  class="gutter-nav-btn"
                  [title]="navNextTitle()"
                  [attr.aria-label]="navNextTitle()"
                  (click)="onNavNext()">›</button>
              </div>
              @if (showCourtPager()) {
                <div class="gutter-pager-row" [title]="courtPagerLabel()">
                  <button
                    type="button"
                    class="gutter-pager-btn"
                    [disabled]="!canPageCourtsLeft()"
                    title="Vorherige Plätze"
                    aria-label="Vorherige Plätze"
                    (click)="pageCourtsLeft()">‹</button>
                  <button
                    type="button"
                    class="gutter-pager-btn"
                    [disabled]="!canPageCourtsRight()"
                    title="Nächste Plätze"
                    aria-label="Nächste Plätze"
                    (click)="pageCourtsRight()">›</button>
                </div>
              }
            </div>
            @for (tick of timeAxisTicks(); track tick.label + tick.top) {
              <div class="time-axis-label" [style.top.px]="tick.top">{{ tick.label }}</div>
            }
            <!-- Current-time chip — sibling of the hour ticks so it scrolls
                 and sticks exactly like them. Label may be empty (tick-
                 collision rule, see nowChip). -->
            @if (nowChip(); as chip) {
              <div class="now-time-chip" [style.top.px]="chip.top">{{ chip.label }}</div>
            }
          </div>

          @for (day of days(); track day.date) {
            <app-court-day-group
              [day]="day"
              [visibleCourtIds]="visibleCourtIds()"
              [pxPerMinute]="pxPerMinute()"
              [intervalMinutes]="intervalMinutes()"
              [courtColumnWidth]="courtColumnWidth()"
              [maxBookableUtc]="maxBookableUtc()"
              (freeCellActivated)="onFreeCellActivated($event)"
              (freeCellDragStarted)="onFreeCellDragStarted($event)"
              (courseSessionClicked)="onCourseSessionClicked($event)" />
          }
        </div>

        <!-- Current-time line — absolutely-positioned child of .grid-inner
             (like the selection overlay): above the segment blocks (z 2),
             below the sticky day headers (z 7) so it slides UNDER them while
             scrolling. Spans the full grid content width (all day-groups in
             week view), starting just after the 50px time gutter. -->
        @if (nowLineTop() !== null) {
          <div class="now-line" [style.top.px]="nowLineTop()"></div>
        }

        @if (overlayGeometry(); as geometry) {
          <div
            #overlayEl
            class="selection-overlay"
            [class.invalid]="isDragInvalid()"
            [class.dragging]="isDragging()"
            [style.left.px]="geometry.left"
            [style.top.px]="geometry.top"
            [style.width.px]="geometry.width"
            [style.height.px]="geometry.height"
            (pointerdown)="onSelectionBodyPointerDown($event)">
            <div class="resize-handle top" (pointerdown)="onResizeHandlePointerDown($event, 'resize-top')">
              <div class="grip"></div>
            </div>
            <span class="selection-label">{{ overlayLabel() }}</span>
            <div class="resize-handle bottom" (pointerdown)="onResizeHandlePointerDown($event, 'resize-bottom')">
              <div class="grip"></div>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="grid-legend">
      <div class="legend-item">
        <span class="legend-swatch legend-free"></span>
        <span>Frei</span>
      </div>
      <div class="legend-item">
        <span class="legend-swatch legend-individual"></span>
        <span>Einzelbuchung</span>
      </div>
      <div class="legend-item">
        <span class="legend-swatch legend-subscription"></span>
        <span>Abo Buchung</span>
      </div>
      <div class="legend-item">
        <span class="legend-swatch legend-course"></span>
        <span>Kurs</span>
      </div>
      <div class="legend-item">
        <span class="legend-swatch legend-event"></span>
        <span>Veranstaltung</span>
      </div>
      <div class="legend-item">
        <span class="legend-swatch legend-blocked"></span>
        <span>Gesperrt</span>
      </div>
      <div class="legend-item">
        <span class="legend-swatch legend-own"></span>
        <span>Eigene Buchung / Teilnahme</span>
      </div>
      <div class="legend-item">
        <span class="legend-swatch legend-selected"></span>
        <span>Aktuelle Auswahl</span>
      </div>
    </div>
  }
</div>
